// import React from 'react';
// import './barchart.css';

// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
// import { Paper, Typography, Box } from "@mui/material";


// const MonthlyComparisonChart = ({ data }) => {
//   const months = [
//     "January", "February", "March", "April", "May", "June",
//     "July", "August", "September", "October", "November", "December"
//   ];

//   // Transform raw data
//   const transformData = (data) => {
//     const monthMap = {};

//     data.forEach((item) => {
//       const monthName = months[item.salesMonth - 1];
//       if (!monthMap[monthName]) {
//         monthMap[monthName] = { month: monthName };
//       }
//       monthMap[monthName][item.salesYear] = item.totalSales;
//     });

//     return months
//       .filter((m) => monthMap[m]) // keep only months present in data
//       .map((m) => monthMap[m]);
//   };

//   const chartData = transformData(data);
//   return (
//     <Box sx={{ width: 950, marginTop: '20px' }}>
//       <Paper elevation={0} sx={{ p: 3, border: '1px solid #ccc', borderRadius: 2 }}>
//         <Typography variant="h6" gutterBottom>
//           Yearly Monthly Sales Comparison
//         </Typography>

//         <ResponsiveContainer width="100%" height={145}>
//           <BarChart margin={{ left: 20, bottom: 5 }} data={chartData}>
//             <XAxis dataKey="month"
//               tick={{
//                 fontSize: 12,
//                 //  angle: -60, dy: 10, textAnchor: 'end'
//               }}
//             />
//             <YAxis
//               ticks={[200000, 400000, 1000000]}
//               domain={[0, 1000000]}
//               tickFormatter={(value) => (value)}
//             />

//             <Tooltip />
//             <Legend />
//             <Bar dataKey={2024} fill="#1976d2" name="2024 Sales" />
//             <Bar dataKey={2025} fill="#ef6c00" name="2025 Sales" />
//           </BarChart>
//         </ResponsiveContainer>



//       </Paper>
//     </Box>
//   );
// };

// export default MonthlyComparisonChart;
import React from 'react';
import './barchart.css';

import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Paper, Typography, Box } from "@mui/material";

// const COLORS = [
//   "#1976d2", // blue
//   "#ef6c00", // orange
//   "#388e3c", // green
//   "#d32f2f", // red
//   "#7b1fa2", // purple
//   "#fbc02d", // yellow
//   "#0097a7", // teal
//   "#5d4037", // brown
// ];

// const MonthlyComparisonChart = ({ data }) => {
//   const months = [
//     "January", "February", "March", "April", "May", "June",
//     "July", "August", "September", "October", "November", "December"
//   ];

//   // Extract unique years from the data dynamically
//   const uniqueYears = [...new Set(data.map(item => item.salesYear))].sort();

//   // Transform raw data
//   const transformData = (data) => {
//     const monthMap = {};

//     data.forEach((item) => {
//       const monthName = months[item.salesMonth - 1];
//       if (!monthMap[monthName]) {
//         monthMap[monthName] = { month: monthName };
//       }
//       monthMap[monthName][item.salesYear] = item.totalSales;
//     });

//     return months
//       .filter((m) => monthMap[m]) // keep only months present in data
//       .map((m) => monthMap[m]);
//   };

//   const chartData = transformData(data);

//   return (
//     <Box sx={{ width: 950, marginTop: '20px' }}>
//       <Paper elevation={0} sx={{ p: 3, border: '1px solid #ccc', borderRadius: 2 }}>
//         <Typography variant="h6" gutterBottom>
//           Yearly Monthly Sales Comparison
//         </Typography>

//         <ResponsiveContainer width="100%" height={145}>
//           <BarChart margin={{ left: 20, bottom: 5 }} data={chartData}>
//             <XAxis
//               dataKey="month"
//               tick={{
//                 fontSize: 12,
//                 // angle: -60, dy: 10, textAnchor: 'end'
//               }}
//             />
//             <YAxis
//               ticks={[200000, 400000, 1000000]}
//               domain={[0, 1000000]}
//               tickFormatter={(value) => value}
//             />
//             <Tooltip />
//             {/* <Legend /> */}
//             {uniqueYears.map((year, index) => (
//               <Bar
//                 key={year}
//                 dataKey={year}
//                 fill={COLORS[index % COLORS.length]}
//                 name={`${year} Sales`}
//               />
//             ))}
//           </BarChart>
//         </ResponsiveContainer>

//       </Paper>
//     </Box>
//   );
// };

// export default MonthlyComparisonChart;



const COLORS = [
  "#1976d2", // blue
  "#ef6c00", // orange
  "#388e3c", // green
  "#d32f2f", // red
  "#7b1fa2", // purple
  "#fbc02d", // yellow
  "#0097a7", // teal
  "#5d4037", // brown
];

const MonthlyComparisonChart = ({ data }) => {
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  // Extract unique years from the data dynamically
  const uniqueYears = [...new Set(data.map(item => item.salesYear))].sort();

  // Transform raw data
  const transformData = (data) => {
    const monthMap = {};

    data.forEach((item) => {
      const monthName = months[item.salesMonth - 1];
      if (!monthMap[monthName]) {
        monthMap[monthName] = { month: monthName };
      }
      monthMap[monthName][item.salesYear] = item.totalSales;
    });

    return months
      .filter((m) => monthMap[m]) // keep only months present in data
      .map((m) => monthMap[m]);
  };

  const chartData = transformData(data);

  return (
    <Box sx={{ width: 950, marginTop: '20px' }}>
      <Paper elevation={0} sx={{ p: 3, border: '1px solid #ccc', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom>
          Yearly Monthly Sales Comparison
        </Typography>

        <ResponsiveContainer width="100%" height={145}>
          <BarChart margin={{ left: 20, bottom: 5 }} data={chartData}>
            <XAxis
              dataKey="month"
              tick={{ fontSize: 12 }}
            />
            <YAxis
              ticks={[0, 200000, 400000, 1000000]}
              domain={[0, 1000000]}
              tickFormatter={(value) => value.toLocaleString('en-IN')}
            />
            <Tooltip
              formatter={(value) => value.toLocaleString('en-IN')}
            />
            {uniqueYears.map((year, index) => (
              <Bar
                key={year}
                dataKey={year}
                fill={COLORS[index % COLORS.length]}
                name={`${year} Sales`}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </Paper>
    </Box>
  );
};

export default MonthlyComparisonChart;
